var _path, _path2, _circle;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIconLayer = function SvgIconLayer(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "currentColor",
    strokeWidth: 0.75,
    d: "M16.435 15.66c0 .111-.057.26-.254.438s-.504.355-.914.512c-.817.313-1.972.514-3.267.514s-2.45-.2-3.267-.514c-.41-.157-.716-.334-.913-.512s-.255-.327-.255-.438.058-.26.255-.438.503-.356.913-.513c.818-.312 1.973-.514 3.267-.514 1.295 0 2.45.202 3.267.514.41.157.717.335.914.513s.254.327.254.438Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M12.314 15.185a.312.312 0 1 1-.626 0zm-.626 0v-5h.625v5z"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 2.5,
    cy: 2.5,
    r: 2.188,
    stroke: "currentColor",
    strokeWidth: 0.625,
    transform: "matrix(-1 0 0 1 14.501 5.5)"
  })));
};
export default SvgIconLayer;